import {
  Button,
  ButtonBase,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Zoom,
} from "@material-ui/core";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { navigate } from "../../../actions/routerResolve";
import { msgAction, msgSimple } from "../../../actions/snackbarActions";
import Step from "../../../components/Step";
import View from "../../../components/View";
import add from "../../../images/add.svg";
import { colors, metrics } from "../../../styles";
import AircraftsService from "../../../tools/AircraftsService";
import AircraftsTypesService from "../../../tools/AircraftsTypesService";
import CostCenterService from "../../../tools/CostCenterService";
import FlightStageService from "../../../tools/FlightStageService";
import MissionService from "../../../tools/MissionService";
import Modal from "./Modal.js";

//SweetAlert
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { MISSION_STATUS } from "../../../enums.js";

const MySwal = withReactContent(Swal);

class MissionRequester extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      mission: {
        id: "new",
        status: "Solicitado",
        cost_center_id: "",
        flight_denomination: "",
        aircraft_type_id: "",
        aircraft_id: "",
        flight_stages: [],
      },
      profiles: ["Teste", "Teste 2"],
      user: {
        profile: "",
      },
      costCenter: [],
      aircraftTypes: [],
      aircrafts: [],
      modal: { id: "new" },
      clickedIndex:0
      // lastDestination: "",
    };
  }
  componentWillMount() {
    if (this.props.match.params.id !== "new") {
      MissionService.getById(this.props.match.params.id).then((result) => {
        if (result.ok) {
          let { mission } = this.state;
          this.setState({
            mission: {
              ...mission,
              flight_stages: result.response.flight_stages,
            },
          });
          this.setState({ isChanged: true });
        }
      });
    }
    MissionService.getTitle().then((result) => {
      if (result.ok) {
        let { mission } = this.state;
        this.setState({
          mission: {
            ...mission,
            flight_denomination: result.response.flightTitle,
          },
        });
        this.setState({ isChanged: true });
      }
    });
    CostCenterService.getActive().then((result) => {
      if (result.ok) {
        this.setState({ costCenter: result.response });
        let { mission } = this.state;
        this.setState({
          mission: { ...mission, cost_center_id: result.response[0].id },
        });
      }
    });
    AircraftsTypesService.getActive().then((result) => {
      if (result.ok) {
        this.setState({ aircraftTypes: result.response, loading: false });
        let { mission } = this.state;
        this.setState({
          mission: { ...mission, aircraft_type_id: result.response[0].id },
        });
      }
    });
    AircraftsService.getActive().then((result) => {
      if (result.ok) {
        this.setState({ aircrafts: result.response, loading: false });
        let { mission } = this.state;
        this.setState({
          mission: { ...mission, aircraft_id: result.response[0].id },
        });
      }
    });
  }

  handleRefreshAircraft = () => {};

  handleClose = () => {
    this.setState({ openModal: !this.state.openModal });
  };

  handleClickOpen = (item) => {
    this.setState({ modal: item });
    this.setState({ openModal: !this.state.openModal });
  };

  handleTime = (value) => {
    if (value === "") {
      return null;
    } else {
      return value;
    }
  };
  handleDate = async (value) => {
    if (value) {
      return moment(value).format("YYYY-MM-DD");
    }
    return null;
  };

  handleSave = async (item, reopenModal = false) => {
    Swal.fire({
      title: "<strong>Deseja realmente salvar a missão?</strong>",
      type: "info",
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: "Sim",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: "Não",
    }).then(async (result) => {
      if (!!result.value) {
        this.setState({ isChanged: false });
        if (item.id === "new") {
          let { mission } = this.state;
          let { flight_stages } = this.state.mission;
          flight_stages.push({ ...item, id: "new" });
          this.setState({ mission: { ...mission, flight_stages } });
          moment.locale("pt-br");
          item.date = moment(item.date).format("YYYY-MM-DD");
          moment.locale("pt-br");
          // tratando datas
          item.date = await this.handleDate(item.date);
          item.departure_date = await this.handleDate(item.date);
          item.arrival_date = await this.handleDate(item.date);

          //Tratando horas
          let aux = item.local_time;
          item.local_time = this.handleTime(aux);
          item.takeoff_time = this.handleTime(aux);
          item.status = MISSION_STATUS.SOLICITADO;

          item.passengers = item.passengers.map((item) => item.value);

          delete item.id;
          FlightStageService.create(item).then((result) => {
            if (result.ok) {
              this.props.msgAction("Etapa criada com sucesso.");
              let { mission } = this.state;
              let { flight_stages } = this.state.mission;
              flight_stages = flight_stages.filter(
                (element) => element.id !== "new"
              );
              flight_stages.push({ ...result.response });
              this.setState({ mission: { ...mission, flight_stages } });
            } else {
              let { mission } = this.state;
              let { flight_stages } = this.state.mission;
              flight_stages = flight_stages.filter(
                (element) => element.id !== "new"
              );
              this.setState({ mission: { ...mission, flight_stages } });
              this.props.msgAction(
                "Erro ao criar etapa",
                "TENTAR NOVAMENTE",
                () => this.handleSave({ ...item, id: "new" })
              );
            }
          });
        } else {
          let { mission } = this.state;
          let { flight_stages } = this.state.mission;
          let index = await flight_stages.findIndex(
            (element) => element.id === item.id
          );
          flight_stages[index].id = "new";
          this.setState({ mission: { ...mission, flight_stages } });
          moment.locale("pt-br");
          item.date = moment(item.date).format("YYYY-MM-DD");

          item.local_time = this.handleTime(item.local_time);
          item.passengers = item.passengers.map((item) => item.value);

          FlightStageService.update(item.id, item).then((result) => {
            if (result.ok) {
              let { mission } = this.state;
              let { flight_stages } = this.state.mission;
              let index = flight_stages.findIndex(
                (element) => element.id === "new"
              );
              flight_stages.splice(index, 1, { ...item });
              this.setState({ mission: { ...mission, flight_stages } });
              this.props.msgAction("Etapa editada com sucesso.");
            } else {
              let { flight_stages } = this.state.mission;
              let index = flight_stages.findIndex(
                (element) => element.id === item.id
              );
              flight_stages[index].id = item.id;
              this.props.msgAction(
                "Erro ao editar etapa",
                "TENTAR NOVAMENTE",
                () => this.handleSave({ ...item })
              );
            }
          });
        }
        this.setState({ openModal: false });
        
        if (reopenModal) {
          let{flight_stages} = this.state.mission
          this.handleClickOpen({
            id: "new",
            from:
              flight_stages &&
              flight_stages.length > 0
                ? flight_stages.at(-1).to
                : "",
            date: item.date
          });
        }
      } else
        return MySwal.fire({
          title: "<p>Operação cancelada!</p>",
          type: "error",
        });
    });
  };

  handleSaveMission = () => {
    Swal.fire({
      title: "<strong>Deseja realmente salvar a missão?</strong>",
      type: "info",
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: "Sim",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: "Não",
    }).then(async (result) => {
      if (!!result.value) {
        if (
          this.state.mission.flight_stages.length > 0 &&
          this.state.mission.cost_center_id
        ) {
          let { mission } = this.state;
          let { flight_stages } = this.state.mission;
          flight_stages = flight_stages.map((element) => element.id);
          delete mission.id;
          MissionService.create({ ...mission, flight_stages }).then(
            (result) => {
              if (result.ok) {
                this.props.navigate("/");
                this.props.msgSimple("Missão criada com sucesso.");
              } else {
                this.props.msgSimple("Não foi possível criar missão.");
              }
            }
          );
        } else {
          this.props.msgSimple(
            "Para criar missão é necessário adicionar pelo menos uma etapa."
          );
        }
      } else
        return MySwal.fire({
          title: "<p>Operação cancelada!</p>",
          type: "error",
        });
    });
  };

  render() {
    return (
      <Zoom in={true}>
        <Grid container item md={12}>
          <View {...this.state.mission} />
          <Modal
            openModal={this.state.openModal}
            func={this.handleClose}
            modal={this.state.modal}
            handleSave={this.handleSave}
            minDate={this.state.minDate}
            lastStep = {this.state.clickedIndex>0 ? this.state.mission.flight_stages[this.state.clickedIndex-1]:null}
          />
          <Grid container style={styles.iboxMain}>
            <Paper style={{ width: "100%", padding: metrics.paddingPage }}>
              <Grid container spacing={8}>
                {/* <Grid item xs={12} md={6} >
                                    <TextField
                                        id="profile"
                                        select
                                        label="Autorizado por"
                                        required
                                        style={{ width: '100%' }}
                                        value={this.state.mission.cost_center_id}
                                        onChange={event => {
                                            let { mission } = this.state;
                                            this.setState({ mission: { ...mission, cost_center_id: event.target.value } })
                                        }}
                                        margin="normal"
                                    >
                                        <MenuItem disabled>
                                            Selecione o Autorizado por
                                    </MenuItem>
                                        {this.state.costCenter.map(element => (
                                            <MenuItem key={element.id} value={element.id}>
                                                {element.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid> */}
                <Grid item xs={12} md={6}>
                  <TextField
                    InputProps={{
                      readOnly: true,
                    }}
                    id="flight_denomination"
                    label="Título do voo"
                    style={{ width: "100%" }}
                    value={this.state.mission.flight_denomination}
                    onChange={(event) => {
                      let { mission } = this.state;
                      this.setState({
                        mission: {
                          ...mission,
                          flight_denomination: event.target.value.toUpperCase(),
                        },
                      });
                      this.setState({ isChanged: true });
                    }}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    id="type_aircraft"
                    select
                    label="Tipo"
                    required
                    style={{ width: "100%" }}
                    value={this.state.mission.aircraft_type_id}
                    onChange={(event) => {
                      let { mission } = this.state;
                      this.setState({
                        mission: {
                          ...mission,
                          aircraft_type_id: event.target.value,
                        },
                      });
                    }}
                    margin="normal"
                    InputProps={{
                      readOnly: true,
                    }}
                  >
                    <MenuItem disabled>Selecione o tipo de aeronave</MenuItem>
                    {this.state.aircraftTypes.map((element) => (
                      <MenuItem key={element.id} value={element.id}>
                        {element.type}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    id="profile"
                    select
                    label="Aeronave"
                    style={{ width: "100%" }}
                    value={this.state.mission.aircraft_id}
                    onChange={(event) => {
                      let { mission } = this.state;
                      this.setState({
                        mission: {
                          ...mission,
                          aircraft_id: event.target.value,
                        },
                      });
                    }}
                    margin="normal"
                    // InputProps={{
                    //   readOnly: true,
                    // }}
                  >
                    <MenuItem disabled>Selecione o Perfil</MenuItem>
                    {this.state.aircrafts.map((element) => (
                      <MenuItem key={element.id} value={element.id}>
                        {element.marks}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid container spacing={8} style={{ marginTop: 20 }}>
                  <Grid item md={3}>
                    <ButtonBase
                      onClick={() =>{
                        this.handleClickOpen({
                          id: "new",
                          from:
                            this.state.mission.flight_stages &&
                            this.state.mission.flight_stages.length > 0
                              ? this.state.mission.flight_stages.at(-1).to
                              : "",
                          date: this.state.mission.flight_stages &&
                          this.state.mission.flight_stages.length > 0
                            ? this.state.mission.flight_stages.at(-1).arrival_date
                            : new Date()
                        })
                      }}
                      style={{
                        backgroundColor: colors.primary_darker,
                        padding: 10,
                        color: colors.white,
                        borderRadius: 10,
                        width: 150,
                        height: 60,
                      }}
                    >
                      <img
                        src={add}
                        alt="Nova etapa"
                        style={{ width: 40, height: 40 }}
                      />
                      <h4 style={{ margin: 0, marginLeft: 5 }}>NOVA ETAPA</h4>
                    </ButtonBase>
                  </Grid>
                  <Grid
                    container
                    item
                    alignItems="center"
                    justify="flex-end"
                    xs={12}
                    sm={12}
                    md={9}
                    lg={9}
                    xl={9}
                  >
                    <Button onClick={this.handleSaveMission} color="primary">
                      Salvar
                    </Button>
                    <Button
                      onClick={() => this.props.navigate("/")}
                      color="secondary"
                    >
                      Cancelar
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
            <Grid container spacing={8} style={{ marginTop: 10 }}>
              {this.state.mission.flight_stages.map((element, index) => (
                <Step
                  index={index}
                  {...element}
                  onClick={() => {
                    this.setState({clickedIndex:index})
                    this.handleClickOpen({ ...element })}}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Zoom>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.usersReducer.users,
});

const mapDispatchToProps = {
  msgSimple,
  msgAction,
  navigate,
};

export default connect(mapStateToProps, mapDispatchToProps)(MissionRequester);

const styles = {
  iboxMain: {
    paddingLeft: "4%",
    paddingRight: "4%",
    marginTop: -20,
  },
  paper: {
    padding: metrics.paddingPage,
  },
  item: {
    // padding:5
  },
};



// WEBPACK FOOTER //
// ./src/routes/missions/missions-requester/index.js